import { render, staticRenderFns } from "./MentionsView.vue?vue&type=template&id=26551258&scoped=true"
var script = {}
import style0 from "./MentionsView.vue?vue&type=style&index=0&id=26551258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26551258",
  null
  
)

export default component.exports